module.exports = __webpack_public_path__ + "img/05.927c4116.png";